import { Show, SimpleShowLayout, NumberField, DateField, FunctionField } from "react-admin";
import { StatusChip } from "../../components/StatusChip";
import { CopyableId } from "../../components/CopyableId";

export const BetShow = () => (
  <Show>
    <SimpleShowLayout>
      <FunctionField label="Bet ID" render={(r: { betId?: string }) => <CopyableId value={r?.betId} />} />
      <FunctionField label="Round ID" render={(r: { roundId?: string }) => <CopyableId value={r?.roundId} />} />
      <FunctionField label="Operator ID" render={(r: { operatorId?: string }) => <CopyableId value={r?.operatorId} />} />
      <FunctionField label="User ID" render={(r: { userId?: string }) => <CopyableId value={r?.userId} />} />
      <FunctionField label="Username" render={(r: { username?: string }) => <CopyableId value={r?.username} />} />
      <FunctionField label="Session ID" render={(r: { operatorSessionId?: string }) => <CopyableId value={r?.operatorSessionId} />} />
      <NumberField source="slot" label="Slot" />
      <FunctionField label="Status" render={(r: { status?: string }) => <StatusChip value={r?.status} />} />
      <NumberField source="betAmount" label="Bet Amount" />
      <NumberField source="payoutMultiplier" label="Payout Multiplier" />
      <NumberField source="payoutAmount" label="Payout Amount" />
      <NumberField source="autoCashoutMultiplier" label="Auto Cashout x" />
      <FunctionField label="Wallet Tx ID" render={(r: { walletTransactionId?: string }) => <CopyableId value={r?.walletTransactionId} />} />
      <DateField source="createdAt" label="Created" showTime />
      <DateField source="updatedAt" label="Updated" showTime />
    </SimpleShowLayout>
  </Show>
);
